<template>
  <v-autocomplete
      v-model="value"
      :items="values"
      item-text="name"
      item-value="id"
      :label="label"
      return-object
      hide-details
  />
</template>

<script>
import VueTypes from "vue-types";

import {SmartOfferBundleCascadeType} from "@/modules/redactor/models/smart-offer/bundle-cascade/SmartOfferBundleCascadeType";

export default {
  name: "r-smart-offer-bundle-cascade-type",
  props: {
    model: VueTypes.instanceOf(SmartOfferBundleCascadeType),
    label: VueTypes.string.def("Kind:")
  },
  computed: {
    value: {
      get: function () {
        return this.model;
      },
      set: function (value) {
        this.$emit("update:model", value);
      }
    },
    values() {
      return SmartOfferBundleCascadeType.getValues();
    }
  }
}
</script>